import _regeneratorRuntime from "@babel/runtime/regenerator";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";

function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it;

  if (typeof Symbol === "undefined" || o[typeof Symbol === "function" ? Symbol.iterator : "@@iterator"] == null) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;
      return function () {
        if (i >= o.length) return {
          done: true
        };
        return {
          done: false,
          value: o[i++]
        };
      };
    }

    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  it = o[typeof Symbol === "function" ? Symbol.iterator : "@@iterator"]();
  return it.next.bind(it);
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

import { CodedError } from '@unimodules/core';
import { canUseDOM } from 'fbjs/lib/ExecutionEnvironment';
import FontObserver from 'fontfaceobserver';
import { FontDisplay } from "./Font.types";

function getFontFaceStyleSheet() {
  if (!canUseDOM) {
    return null;
  }

  var styleSheet = getStyleElement();
  return styleSheet.sheet ? styleSheet.sheet : null;
}

function getFontFaceRules() {
  var sheet = getFontFaceStyleSheet();

  if (sheet) {
    var rules = _toConsumableArray(sheet.cssRules);

    var items = [];

    for (var i = 0; i < rules.length; i++) {
      var rule = rules[i];

      if (rule instanceof CSSFontFaceRule) {
        items.push({
          rule: rule,
          index: i
        });
      }
    }

    return items;
  }

  return [];
}

function getFontFaceRulesMatchingResource(fontFamilyName, options) {
  var rules = getFontFaceRules();
  return rules.filter(function (_ref) {
    var rule = _ref.rule;
    return rule.style.fontFamily === fontFamilyName && (options && options.display ? options.display === rule.style.fontDisplay : true);
  });
}

export default {
  get name() {
    return 'ExpoFontLoader';
  },

  unloadAllAsync: function unloadAllAsync() {
    var element;
    return _regeneratorRuntime.async(function unloadAllAsync$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (canUseDOM) {
              _context.next = 2;
              break;
            }

            return _context.abrupt("return");

          case 2:
            element = document.getElementById(ID);

            if (element && element instanceof HTMLStyleElement) {
              document.removeChild(element);
            }

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, null, null, null, Promise);
  },
  unloadAsync: function unloadAsync(fontFamilyName, options) {
    var sheet, items, _iterator, _step, item;

    return _regeneratorRuntime.async(function unloadAsync$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            sheet = getFontFaceStyleSheet();

            if (sheet) {
              _context2.next = 3;
              break;
            }

            return _context2.abrupt("return");

          case 3:
            items = getFontFaceRulesMatchingResource(fontFamilyName, options);

            for (_iterator = _createForOfIteratorHelperLoose(items); !(_step = _iterator()).done;) {
              item = _step.value;
              sheet.deleteRule(item.index);
            }

          case 5:
          case "end":
            return _context2.stop();
        }
      }
    }, null, null, null, Promise);
  },
  loadAsync: function loadAsync(fontFamilyName, resource) {
    var canInjectStyle, style;
    return _regeneratorRuntime.async(function loadAsync$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            if (canUseDOM) {
              _context3.next = 2;
              break;
            }

            return _context3.abrupt("return");

          case 2:
            canInjectStyle = document.head && typeof document.head.appendChild === 'function';

            if (canInjectStyle) {
              _context3.next = 5;
              break;
            }

            throw new CodedError('ERR_WEB_ENVIRONMENT', "The browser's `document.head` element doesn't support injecting fonts.");

          case 5:
            style = _createWebStyle(fontFamilyName, resource);
            document.head.appendChild(style);

            if (isFontLoadingListenerSupported()) {
              _context3.next = 9;
              break;
            }

            return _context3.abrupt("return");

          case 9:
            return _context3.abrupt("return", new FontObserver(fontFamilyName, {
              display: resource.display
            }).load());

          case 10:
          case "end":
            return _context3.stop();
        }
      }
    }, null, null, null, Promise);
  }
};
var ID = 'expo-generated-fonts';

function getStyleElement() {
  var element = document.getElementById(ID);

  if (element && element instanceof HTMLStyleElement) {
    return element;
  }

  var styleElement = document.createElement('style');
  styleElement.id = ID;
  styleElement.type = 'text/css';
  return styleElement;
}

function _createWebStyle(fontFamily, resource) {
  var fontStyle = "@font-face {\n    font-family: " + fontFamily + ";\n    src: url(" + resource.uri + ");\n    font-display: " + (resource.display || FontDisplay.AUTO) + ";\n  }";
  var styleElement = getStyleElement();

  if (styleElement.styleSheet) {
    var styleElementIE = styleElement;
    styleElementIE.styleSheet.cssText = styleElementIE.styleSheet.cssText ? styleElementIE.styleSheet.cssText + fontStyle : fontStyle;
  } else {
    var textNode = document.createTextNode(fontStyle);
    styleElement.appendChild(textNode);
  }

  return styleElement;
}

function isFontLoadingListenerSupported() {
  var userAgent = window.navigator.userAgent;
  var isIOS = !!userAgent.match(/iPad|iPhone/i);
  var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  var isEdge = userAgent.includes('Edge');
  var isFirefox = userAgent.includes('Firefox');
  return !isSafari && !isIOS && !isEdge && !isFirefox;
}